var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:{
    'mb-3 mr-3': _vm.$vuetify.breakpoint.xs, 
    'ml-3': _vm.$vuetify.breakpoint.smAndDown,
    'mt-3 ml-3 mb-0': _vm.$vuetify.breakpoint.mdAndUp, 
    'pa-2' : true, 
    'body-2' : true, 
    'd-flex align-center justify-start' : true },attrs:{"elevation":"2"}},[_c('v-list-item-avatar',[_c('v-img',{attrs:{"src":require("../assets/profile.png")}})],1),_c('h4',[_vm._v(_vm._s(_vm.$t('dashboard.hello'))+" Richard Martin")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }